interface Config {
    xola: {
        url: string;
        loginUrl: string;
        apiVersion: string;
    };

    oauth: {
        clientId: string;
        proxyEnvironment?: string;
    };

    xolaWaivers: {
        url: string;
        pluginUserId: string;
    };

    xchat: {
        ui: string;
        api: string;
    };

    sumologic: {
        endpoint: string;
    };

    elrond: {
        url: string;
        ui: string;
    };

    tutorials: {
        url: string;
    };

    checkout: {
        url: string;
        x2Url?: string;
    };

    gift: {
        url: string;
    };

    agGrid: {
        key: string;
    };

    pusher: {
        key: string;
        cluster: string;
    };

    stripe: {
        publicKey: string;
    };

    sentry: {
        organization?: string;
        dsn: string;
    };

    postmark?: {
        url: string;
    };

    google: {
        apiKey: string;
        tagManagerId: string;
        gtm_auth?: string;
        gtm_preview?: string;
        gtm_cookies_win?: string;
        gtmUserEventName: string;
        place_url: string;
    };

    fullstory: {
        id: string;
    };

    fullCalendar: {
        licenseKey: string;
    };

    geonames: {
        username: string;
        url: string;
    };

    elasticsearch: {
        indexes: {
            order: string;
            purchase: string;
            transaction: string;
            gift: string;
            store_credit: string;
            membership_order: string;
            waitlist: string;
        };
    };

    redemptionApp: {
        url: string;
        version: string;
    };

    scheduler: {
        url: string;
    };

    feedback: {
        url: string;
    };

    localize: {
        key: string;
        enabled: boolean;
    };

    admin?: {
        url: string;
    };
}

export const config = process.env.CONFIG as unknown as Config;
